"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExportDialogBase = void 0;
var tslib_1 = require("tslib");
// (C) 2020 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var DialogBase_1 = require("./DialogBase");
var noop_1 = tslib_1.__importDefault(require("lodash/noop"));
var Form_1 = require("../Form");
var ConfirmDialogBase_1 = require("./ConfirmDialogBase");
/**
 * @internal
 */
var ExportDialogBase = /** @class */ (function (_super) {
    tslib_1.__extends(ExportDialogBase, _super);
    function ExportDialogBase() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            includeFilterContext: _this.props.includeFilterContext,
            mergeHeaders: _this.props.mergeHeaders,
        };
        _this.onFilterContextChange = function (value) {
            _this.setState({ includeFilterContext: value });
        };
        _this.onMergeHeadersChange = function (value) {
            _this.setState({ mergeHeaders: value });
        };
        _this.onSubmit = function () {
            var filterContextVisible = _this.props.filterContextVisible;
            var _a = _this.state, includeFilterContext = _a.includeFilterContext, mergeHeaders = _a.mergeHeaders;
            _this.props.onSubmit({
                includeFilterContext: filterContextVisible && includeFilterContext,
                mergeHeaders: mergeHeaders,
            });
        };
        return _this;
    }
    ExportDialogBase.prototype.render = function () {
        var _a = this.props, displayCloseButton = _a.displayCloseButton, isPositive = _a.isPositive, isSubmitDisabled = _a.isSubmitDisabled, headline = _a.headline, cancelButtonText = _a.cancelButtonText, submitButtonText = _a.submitButtonText, onCancel = _a.onCancel, filterContextText = _a.filterContextText, filterContextTitle = _a.filterContextTitle, filterContextVisible = _a.filterContextVisible, mergeHeadersDisabled = _a.mergeHeadersDisabled, mergeHeadersText = _a.mergeHeadersText, mergeHeadersTitle = _a.mergeHeadersTitle;
        var _b = this.state, includeFilterContext = _b.includeFilterContext, mergeHeaders = _b.mergeHeaders;
        var filterContextCheckbox;
        if (filterContextVisible) {
            filterContextCheckbox = (react_1.default.createElement(Form_1.Checkbox, { name: "gs.dialog.export.checkbox.includeFilterContext", text: filterContextText, title: filterContextTitle, value: includeFilterContext, onChange: this.onFilterContextChange }));
        }
        return (react_1.default.createElement(ConfirmDialogBase_1.ConfirmDialogBase, { className: "gd-export-dialog", displayCloseButton: displayCloseButton, isPositive: isPositive, isSubmitDisabled: isSubmitDisabled, headline: headline, cancelButtonText: cancelButtonText, submitButtonText: submitButtonText, onCancel: onCancel, onSubmit: this.onSubmit },
            react_1.default.createElement(Form_1.Checkbox, { disabled: mergeHeadersDisabled, name: "gs.dialog.export.checkbox.mergeHeaders", text: mergeHeadersText, title: mergeHeadersTitle, value: mergeHeaders, onChange: this.onMergeHeadersChange }),
            filterContextCheckbox));
    };
    ExportDialogBase.defaultProps = {
        displayCloseButton: true,
        isPositive: true,
        isSubmitDisabled: false,
        headline: "Export to XLSX",
        cancelButtonText: "Cancel",
        submitButtonText: "Export",
        filterContextText: "Include applied filters",
        filterContextTitle: "INSIGHT CONTEXT",
        filterContextVisible: true,
        includeFilterContext: true,
        mergeHeaders: true,
        mergeHeadersDisabled: false,
        mergeHeadersText: "Keep attribute cells merged",
        mergeHeadersTitle: "CELLS",
        onCancel: noop_1.default,
        onSubmit: noop_1.default,
    };
    return ExportDialogBase;
}(DialogBase_1.DialogBase));
exports.ExportDialogBase = ExportDialogBase;
//# sourceMappingURL=ExportDialogBase.js.map